export default function addScrollListener(target: EventTarget, onScroll: () => void) {
  target.addEventListener('scroll', onScroll, { passive: true });
  return () =>
    target.removeEventListener('scroll', onScroll, {
      // @ts-expect-error sigh, not sure why Typescript isn't aware of this option
      passive: true,
    });
}
